const childRoutes = (prop) => [
    {
        path: 'test',
        name: prop + '.test',
        meta: { auth: true },
        component: () => import('../pages/Test.vue')
    },
    {
        path: 'budget-preparation',
        name: prop + '.budget_preparation',
        meta: { auth: true },
        component: () => import('../pages/budget-preparation/List.vue')
    },
    {
        path: 'budget-approval',
        name: prop + '.budget_approval',
        meta: { auth: true },
        component: () => import('../pages/budget-approval/List.vue')
    },
    {
        path: 'budget-preparation-add',
        name: prop + '.budget_preparation_add',
        meta: { auth: true },
        component: () => import('../pages/budget-preparation/Form.vue')
    },
    {
        path: 'budget-approval-update',
        name: prop + '.budget_approval_update',
        meta: { auth: true },
        component: () => import('../pages/budget-approval/Update.vue')
    },
    {
        path: 'budget-allocation',
        name: prop + '.budget_allocation',
        meta: { auth: true },
        component: () => import('../pages/budget-allocation/List.vue')
    },
    {
        path: 'budget-allocation-add',
        name: prop + '.budget_allocation_add',
        meta: { auth: true },
        component: () => import('../pages/budget-allocation/Form.vue')
    },
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard/List.vue')
    }
]

const routes = [{
    path: '/grant-allowance-service/budget-management',
    name: 'grant_allowance_service.budget_management',
    component: () => import('@/layouts/GrantAllowanceLayout.vue'),
    meta: { auth: true },
    children: childRoutes('grant_allowance_service.budget_management')
}]

export default routes
